/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import {
  addItemInSelectedVehicle,
  addItemInSelectedPart,
} from "../../../store/SurveyPageData";
import DialogView from "../dialog/DialogView";
import CopyPasteFunctionality from "../../survey/CopyPasteFunctionality";
import DeleteView from "../../survey/DeleteView";
import { addItemInVehicleListUpdate } from "../../../store/SurveyPageData";
import "./TableView.css";
import { postRequest } from "../../../services/RequestConfig";
import Loader from "../../common/dialog/Loader";
import {
  APPEND_PARTS,
  DELETE_LABEL,
  MAXHEIGHT220,
  MAXHEIGHT420,
  MINWIDTH750,
  NO_RECORDS,
  PARTS,
  POINTER,
  TABLE_PAGINATION_COUNT,
  UNIT,
  VEHICLE,
  VEHICLE_TO_COPY,
} from "../../../utils/GlobalConstants";
import {
  PARTS_HEAD_CELLS,
  VEHICLE_HEAD_CELLS,
  VEHICLES_TO_COPY,
  VEHICLE_TABLE_SURVEY,
  VEHICLE_TO_COPY_TABLE_SURVEY,
} from "../../../utils/GlobalFormConstants";
import {
  StyledTableRow,
  getComparator,
  stableSort,
  EnhancedTableHead,
  EnhancedTableToolbar,
  getAllParts,
  EnhancedCell,
  transformToTable,
} from "./TableCommon";
import { getSingleSurvey } from "../../../services/SurveyRequest";
import { constructDCStore } from "../../../utils/genericUse/CommonUse";
const TableView = (props) => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rows, setrows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [open, setOpen] = React.useState(false);
  const [rad, setrad] = React.useState("");
  const [selectedID, setSelectedID] = React.useState(null);
  const [del, setdel] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const[ loaderSurvery, setLoaderSurvey] =React.useState(false)
  const dispatch = useDispatch();
  const tableRef = React.createRef();
  const selectedSurvey = useSelector(
    (state) => state?.SurveyPageData?.selectedSurvey
  );

  const updateVehicleList = useSelector((state) => {
    return state?.SurveyPageData?.vehicleListUpdate;
  });
  const updatePartsInfo = useSelector(
    (state) => state?.SurveyPageData?.partListUpdate
  );
  const selectedVehicle = useSelector(
    (state) => state?.SurveyPageData?.selectedVehicle
  );
  const selectedPart = useSelector(
    (state) => state?.SurveyPageData?.selectedPart
  );

  const headCells =
    props.source === VEHICLE
      ? VEHICLE_HEAD_CELLS
      : props.source === VEHICLE_TO_COPY
        ? VEHICLES_TO_COPY
        : PARTS_HEAD_CELLS;

  const getAllVehicles = async (
    source,
    selectedSurvey,
    selectedVehicle,
    setOrder,
    setOrderBy,
    setPage,
    setrows
  ) => {
    if (source === VEHICLE && selectedSurvey?.surveyName?.length > 0) {
      try {
        setLoaderSurvey(true)
        const response = await getSingleSurvey(selectedSurvey.id);
        const tmparr = [...response?.vehicles];
        if (tmparr.length > 0) {
          const index = tmparr?.findIndex((item) => {
            return item?.id === selectedVehicle?.id;
          });
          const spliceData = tmparr?.splice(index, 1)[0];
          tmparr.splice(0, 0, spliceData);
        }
        
        const transformedData = transformToTable(VEHICLE_TABLE_SURVEY, tmparr);
        setOrder("");
        setOrderBy("");
        setPage(0);
      
        setrows(transformedData);
          setLoaderSurvey(false)
      } catch (e) {
        console.log(e);
          setLoaderSurvey(false)
      }
    } else {
      setrows([]);
    }
    if (source === VEHICLE_TO_COPY && selectedSurvey?.surveyName?.length > 0) {
      try {
        const response = await getSingleSurvey(selectedSurvey.id);

        const localArr = [...response?.vehicles];

        const tmparr = localArr.filter(
          (ele) => ele?.id !== selectedVehicle?.id
        );
        const transformedData = transformToTable(
          VEHICLE_TO_COPY_TABLE_SURVEY,
          tmparr
        );
        setOrder("");
        setOrderBy("");
        setrows(transformedData);
      } catch (e) {
        console.log(e);
      }
    }
  };
  React.useEffect(() => {
    getAllVehicles(
      props.source,
      selectedSurvey,
      selectedVehicle,
      setOrder,
      setOrderBy,
      setPage,
      setrows
    );
  }, [selectedSurvey, updateVehicleList, props.source]);

  React.useEffect(() => {
    if (props.source === VEHICLE) {
      setSelectedID(selectedVehicle?.id);
    }
    getAllParts(props.source, selectedVehicle, setrows);
    setSelected([]);
    dispatch(addItemInSelectedPart({}));
  }, [selectedVehicle, updatePartsInfo, dispatch, props.source]);
  React.useEffect(() => {
    if (props.source === PARTS) {
      setSelectedID(selectedPart?.id);
    }
  }, [selectedPart, props.source]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = async (event, id, row) => {
    setSelectedID(id);
    if (props.source === VEHICLE) {
      dispatch(
        addItemInSelectedVehicle({
          ...row.source,
          vinValidation : !row.source?.vinFlag? row?.source?.vinValid:'',
          unitNo: row.values.unitNo.displayValue,
          sortBy: row.values.sortBy.displayValue,
          makeModel: row.values.makeModel.displayValue,
        })
      );
    }
    if (props.source === PARTS) {
      dispatch(addItemInSelectedPart(row.source));
    }
  };
  const handleClickCheckbox = (event, id, row) => {
    event.stopPropagation();
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    tableRef.current && tableRef.current.scrollIntoView({});
    window.scroll({ top: 100 });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(() => {
    return stableSort(rows, getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [order, orderBy, page, rowsPerPage, rows]);
  const handleClose = () => {
    setOpen(false);
  };
  const handleClosedel = () => {
    setdel(false);
  };
  const handleChange = (e, row, value) => {
    if (value === UNIT) handleChangeUnit(e, row);
    else handleChangeSort(e, row);
  };
  const handleChangeUnit = (e, row) => {
    let newUnit;
    newUnit = constructDCStore(e.target.value);
    setrows((prevData) =>
      prevData.map((item) =>
        item.id === row.id
          ? {
            ...item,
            values: {
              ...item.values,
              unitNo: { ...item.values.unitNo, displayValue: newUnit },
            },
          }
          : item
      )
    );
  };
  const handleChangeSort = (e, row) => {
    setrows((prevData) =>
      prevData.map((item) =>
        item.id === row.id
          ? {
            ...item,
            values: {
              ...item.values,
              sortBy: { ...item.values.sortBy, displayValue: e.target.value },
            },
          }
          : item
      )
    );
  };
  const getPayload = (row) => {
    return {
      surveyId: selectedSurvey.id,
      updateType: 0,
      vehicles: [
        {
          id: row.id,
          surveyId: selectedSurvey.id,
          vin: row.source.vin,
          make: row.source.make,
          model: row.source.model,
          makeModel: row.source.makeModel,
          engine: row.source.engine,
          subModel: row.source.subModel,
          unitNo: row.values.unitNo.displayValue,
          sortBy: row.values.sortBy.displayValue,
          year: row.source.year,
          comments: row.source.comments,
        },
      ],
    };
  };
  const handleBlurUnit = async (e, row) => {
    const payload = getPayload(row);
    setIsLoading(true);
    try {
      const res = await postRequest("vehicle", payload);
      dispatch(addItemInVehicleListUpdate([...res?.data?.id]));
      dispatch(
        addItemInSelectedVehicle({
          ...row.source,
          unitNo: row.values.unitNo.displayValue,
          sortBy: row.values.sortBy.displayValue,
          makeModel: row.values.makeModel.displayValue,
        })
      );
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };
  const handleBlurSort = async (e, row) => {
    const payload = getPayload(row);
    try {
      setIsLoading(true);
      const res = await postRequest("vehicle", payload);
      dispatch(addItemInVehicleListUpdate([...res?.data?.id]));
      dispatch(
        addItemInSelectedVehicle({
          ...row.source,
          unitNo: row.values.unitNo.displayValue,
          sortBy: row.values.sortBy.displayValue,
          makeModel: row.values.makeModel.displayValue,
        })
      );
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };
  const handleBlur = async (e, row, from) => {
    if (from === "unit") handleBlurUnit(e, row);
    else handleBlurSort(e, row);
  };

  return (
    <>
      <DialogView
        open={open}
        testid={APPEND_PARTS}
        handleClose={() => handleClose()}
        width={"43%"}
        maxWidth={"75em!important"}
        heading={APPEND_PARTS}
        childComponet={
          <CopyPasteFunctionality
            rows={rows}
            selected={selected}
            selectedSurveyId={selectedSurvey?.id}
            handleClose={handleClose}
            setSelected={setSelected}
            setIsLoading={setIsLoading}
          />
        }
      />

      <DialogView
        open={del}
        testid={DELETE_LABEL}
        maxWidth={"30em!important"}
        heading={DELETE_LABEL}
        handleClose={() => handleClosedel()}
        childComponet={
          <DeleteView
            source={props.source}
            selected={selected}
            selectedSurveyId={selectedSurvey?.id}
            handleClosedel={handleClosedel}
            setIsLoading={setIsLoading}
            setSelected={setSelected}
          />
        }
      />
      <Box>
        <Paper className="mainTablePaper">
          <EnhancedTableToolbar
            numSelected={selected.length}
            source={props.source}
            setOpen={setOpen}
            setdel={setdel}
          />
          <TableContainer
            sx={props.source === VEHICLE ? MAXHEIGHT420 : MAXHEIGHT220}
          >
            <Table
              stickyHeader
              sx={MINWIDTH750}
              aria-labelledby="tableTitle"
              size={"small"}
              ref={tableRef}
              overflow="clip"
            >
              <EnhancedTableHead
                headCells={headCells}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                source={props.source}
              />
              
              {visibleRows.length > 0 ? (
                <TableBody>
                  {visibleRows.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <StyledTableRow
                        hover
                        testid="rowclick"
                        onClick={(event) => handleClick(event, row.id, row)}
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={selectedID === row.id}
                        sx={POINTER}
                      >
                       {Object.entries(row.values).map(([key, value]) => {
                          return (
                            <><EnhancedCell
                              key={key}
                              type={value.type}
                              value={value}
                              selectedID={selectedID}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              row={row}
                              handleClickCheckbox={handleClickCheckbox}
                              isItemSelected={isItemSelected}
                              labelId={labelId}
                              rad={rad}
                              setrad={setrad}
                              handleRadio={props.handleRadio}
                            />
                            </>
                          );
                        })}
                        
                      </StyledTableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <StyledTableRow>
                      <TableCell colSpan={6} />
                    </StyledTableRow>
                  )}
                </TableBody>
              ) : (
                <div className="noRecords">{NO_RECORDS} </div>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            className="tablePagination"
            rowsPerPageOptions={TABLE_PAGINATION_COUNT}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      {(isLoading || loaderSurvery) && <Loader className="Loader-style" />}
    </>
  );
};
export default TableView;
